import { setUser } from '../slice/user.web.slice';

export const userSliceUpdatedEvent = setUser;
